export default {
  english: {
    errors: {
      requiredField: '{{ label }} field is mandatory',
    },
  },
  french: {
    errors: {
      requiredField: 'Le champ "{{ label }}" est obligatoire',
    },
  },
  arabic: {
    errors: {
      requiredField: 'حقل "{{ label }}" مطلوب',
    },
  },
  hebrew: {
    errors: {
      requiredField: 'השדה "{{ label }}" הוא חובה',
    },
  },
  persian: {
    errors: {
      requiredField: 'فیلد "{{ label }}" اجباری است',
    },
  },
}
